import { convertMany } from 'convert'
import {
  GeckoMeasurement,
  GeckoMeasurementUnit,
  GeckoNozzleJSON,
  generateNozzle,
} from 'types/index'
import { v4 as uuid4 } from 'uuid'

export function generateNozzles_FastField(
  nozzles: Array<Record<string, number | Record<string, string>>>
): Map<string, GeckoNozzleJSON> {
  const nozzleMap = new Map<string, GeckoNozzleJSON>()
  // Return early if we don't have any nozzles to build
  if (!nozzles) {
    return nozzleMap
  }

  nozzles.forEach((nozzle, index) => {
    const nozzleFields = nozzle.fields as Record<string, string>
    const nozzleYPosition = convertMany(nozzleFields.nozzle_cl).to('ft')
    const nozzleXPosition = convertMany(nozzleFields.nozzle_station).to('ft')
    const nozzleRadius = convertMany(nozzleFields.nozzle_diameter).to('ft') / 2

    const yPosGM = GeckoMeasurement.CreateFromValue(
      nozzleYPosition,
      GeckoMeasurementUnit.Feet
    )
    const xPosGM = GeckoMeasurement.CreateFromValue(
      nozzleXPosition,
      GeckoMeasurementUnit.Feet
    )
    const radiusGM = GeckoMeasurement.CreateFromValue(
      nozzleRadius,
      GeckoMeasurementUnit.Feet
    )

    const nozzleJSON = generateNozzle(
      `Nozzle ${index + 1}`,
      xPosGM,
      yPosGM,
      radiusGM,
      undefined,
      nozzleFields.nozzle_notes || ''
    )

    const nozzleID = uuid4().slice(0, 6)
    nozzleMap.set(nozzleID, nozzleJSON)
  })
  return nozzleMap
}
